
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
@Component
export default class SelectTime extends Vue {
  @Prop({ default: true }) private isCustomize!: boolean;
  private formItem: objAny = {
    startTime: "",
    endTime: ""
  };

  private timeType = "1";
  private times: Date[] = [];
  private timeTypeList: objAny = {
    "1": i18n.t("formText.time24"),
    "2": i18n.t("formText.time7"),
    "3": i18n.t("formText.time30"),
    "4": i18n.t("formText.timeCustom")
  };
  public timeTypeChange(val: string): void {
    const timestamp = new Date().getTime();
    let startTime = "";
    let endTime = "";
    // const timeType = "";
    endTime = this.$common.userDate(timestamp);
    if (val == "1") {
      const t = (timestamp / 1000 - 60 * 60 * 24) * 1000;
      startTime = this.$common.userDate(t);
    } else if (val == "2") {
      const t = (timestamp / 1000 - 60 * 60 * 24 * 7) * 1000;
      startTime = this.$common.userDate(t);
    } else if (val == "3") {
      const t = (timestamp / 1000 - 60 * 60 * 24 * 30) * 1000;
      startTime = this.$common.userDate(t);
    } else {
      this.setThreeDay();
      startTime = this.$common.userDate(this.times[0]);
      endTime = this.$common.userDate(this.times[1]);
    }
    this.$emit("change", {
      startTime: startTime,
      endTime: endTime,
      timeType: val
    });
  }
  public timeChange(val: string): void {
    if (val) {
      this.$emit("change", {
        startTime: val[0] + " 00:00:00",
        endTime: val[1] + " 23:59:59"
      });
    } else {
      this.$emit("change", { startTime: "", endTime: "" });
    }
  }

  /**
   * 设置当前一周时间
   */
  setThreeDay() {
    const day = new Date(new Date().setDate(new Date().getDate() - 3));
    this.times.splice(0, 0, day, new Date());
  }

  mounted() {
    this.timeTypeChange("1");
  }
}
